import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M3.64696 5.5863C3.87033 5.37768 4.17025 5.25 4.5 5.25H19.5C19.8297 5.25 20.1297 5.37768 20.353 5.5863L12.8839 13.0555C12.3957 13.5436 11.6043 13.5436 11.1161 13.0555L3.64696 5.5863ZM3.25 7.31066V17.5C3.25 18.1904 3.80964 18.75 4.5 18.75H19.5C20.1904 18.75 20.75 18.1904 20.75 17.5V7.31066L13.9445 14.1161C12.8706 15.1901 11.1294 15.1901 10.0555 14.1161L3.25 7.31066ZM4.5 3.75C2.98122 3.75 1.75 4.98122 1.75 6.5V17.5C1.75 19.0188 2.98122 20.25 4.5 20.25H19.5C21.0188 20.25 22.25 19.0188 22.25 17.5V6.5C22.25 4.98122 21.0188 3.75 19.5 3.75H4.5Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
